import { forwardRef, type ButtonHTMLAttributes } from 'react';

import { cn } from '@/lib/cn';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'ghost' | 'outline' | 'accent' | 'danger';
  size?: 'sm' | 'md' | 'icon';
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = 'default', size = 'md', type = 'button', ...props }, ref) => {
    return (
      <button
        ref={ref}
        type={type}
        className={cn(
          'inline-flex items-center justify-center gap-1.5 font-medium transition-colors duration-100',
          'disabled:pointer-events-none disabled:opacity-40',
          'focus-visible:outline focus-visible:outline-1 focus-visible:outline-offset-2 focus-visible:outline-accent',
          variant === 'default' && 'bg-surface-2 text-text border border-border hover:border-border-strong hover:bg-row-hover',
          variant === 'ghost' && 'text-text-muted hover:text-text hover:bg-row-hover',
          variant === 'outline' && 'border border-border bg-transparent text-text hover:border-border-strong hover:bg-row-hover',
          variant === 'accent' && 'bg-accent text-bg hover:brightness-110 border border-transparent',
          variant === 'danger' && 'text-danger hover:bg-row-hover',
          size === 'sm' && 'h-7 px-2 text-xs',
          size === 'md' && 'h-8 px-3 text-xs',
          size === 'icon' && 'h-7 w-7 p-0',
          className,
        )}
        {...props}
      />
    );
  },
);
Button.displayName = 'Button';
